import { route } from '@helpers'
import React from 'react'
import { Link } from 'react-router-dom'

export default function SalonEditHeading({ salon }: Props) {
    return (
        <>
            <Link to={route("admin:salons")}>Salons</Link> — <Link to={route("admin:salon", salon.id)}>{salon.name}</Link> — Edit
        </>
    )
}

interface Props {
    salon: Admin.Resources.Salon
}